import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getQueryStringResults } from '@plone/volto/actions/querystringsearch/querystringsearch';
import { formatUrl } from '@plone/volto/helpers/Api/Api';

import { buildEspecialitatsSelectOptions } from './api';
import { ESPECIALITATS_LISTING_BATCH_SIZE } from './listingPagination';

const getSubrequestId = (language) => `especialitats-select-${language}`;

export const useEspecialitatsSelectOptions = (language) => {
  const dispatch = useDispatch();
  const subrequestID = useMemo(
    () => (language ? getSubrequestId(language) : null),
    [language],
  );
  const subrequest = useSelector((state) =>
    subrequestID
      ? state.querystringsearch.subrequests[subrequestID]
      : undefined,
  );

  useEffect(() => {
    if (
      !language ||
      !subrequestID ||
      subrequest?.loaded ||
      subrequest?.loading
    ) {
      return undefined;
    }

    dispatch(
      getQueryStringResults(
        formatUrl(`/${language}/serveis-medics/especialitats`),
        { b_size: ESPECIALITATS_LISTING_BATCH_SIZE },
        subrequestID,
      ),
    );

    return undefined;
  }, [
    dispatch,
    language,
    subrequest?.loaded,
    subrequest?.loading,
    subrequestID,
  ]);

  return useMemo(
    () => buildEspecialitatsSelectOptions(subrequest?.items, language),
    [language, subrequest?.items],
  );
};
